import { NgClass } from '@angular/common';
import { NgModule } from '@angular/core';
import { TimeDisplayComponent } from '@go-modules/components/time-display/time-display.component';
import { FormatTimeModule } from '@go-modules/pipes/format-time/format-time.module';

@NgModule({
	declarations: [
		TimeDisplayComponent
	],
	exports: [
		TimeDisplayComponent
	],
	imports: [
		FormatTimeModule,
		NgClass
	]
})
export class TimeDisplayModule {}
